import { useState } from "react";
import { useLoaderData, useNavigate } from "react-router-dom";
import { brandModelsSchema, BrandModelsType } from "../../../types/brandModels";
import CarModelsView from "./CarModelsView";

export default function CarModels() {
  const navigate = useNavigate();
  const data = useLoaderData();
  const [search, setSearch] = useState("");

  const brandModels: BrandModelsType = brandModelsSchema.parse(data);
  const filteredModels = brandModels.installations.filter((i) =>
    i.model.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <CarModelsView
      brand={brandModels.brand}
      installations={filteredModels}
      onClick={() => navigate(-1)}
      onChange={(text) => setSearch(text)}
    />
  );
}
